import React from 'react';
import * as FiIcons from 'react-icons/fi';

const SafeIcon = ({ icon, className, ...props }) => {
  const IconComponent = icon;
  
  if (!IconComponent) {
    return <FiIcons.FiAlertTriangle className={className} {...props} />;
  }
  
  return <IconComponent className={className} {...props} />;
};

export default SafeIcon;